<div class="box">
  <div class="mouse one">
    <div class="key"></div>
  </div>

  <div class="mouse two">
    <div class="key"></div>
  </div>

  <div class="mouse three">
    <div class="key"></div>
  </div>
</div>
